import React from 'react';
import cn from 'classnames';
import * as s from './landing-video.module.less';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import * as landingPageStyle from '../landing-page.module.less';
import Button from '../../button';
import BackgroundImage from 'gatsby-background-image';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import ReactMarkdown from 'react-markdown';
import HeroCustomerLogos from '../hero-customer-logos';

export const LandingVideo = ({
	backgroundImageUrl,
	content,
	socialProofCustomers,
	defaultBackgroundColor
}) => {
	const { t } = useTranslation();
	const {
		heading,
		subheadline,
		description,
		btn,
		textColor = '#FFFFFF',
		subheadlineColor = '#EEEEEE',
		listColor = '#FFFFFF',
		logoTitleColor = '#CCCCCC',
		illustration = undefined,
	} = content;

	const RootElement = backgroundImageUrl ? BackgroundImage : 'div';
	const rootProps = backgroundImageUrl
		? { Tag: 'div', className: s.landing, fluid: backgroundImageUrl }
		: defaultBackgroundColor
			? { className: cn(s.landing, s.solidBackground), style: { background: defaultBackgroundColor } }
			: { className: cn(s.landing, s.solidBackground) };

	return (
		<RootElement {...rootProps}>
			<div className={cn(landingPageStyle.container, s.heroContainer)}>
				<div className={s.heroLayout}>
					<div className={s.leftColumn}>
						<div className={s.row}>
							<div>
								<h1 className={ s.heading } style={{ color: textColor }}>
									<ReactMarkdown children={heading} />
								</h1>

								{subheadline && <p className={ s.subheadline } style={{ color: subheadlineColor }}>{subheadline}</p>}

								{description?.list && description.list.length > 0 && (
									<ul className={ s.descriptionList }>
										{ description.list.map((item, index) => (
											<li key={index} style={{ color: listColor }}>
												<div className={cn(s.check, {
													[s.black]: listColor !== '#FFFFFF' &&	 listColor !== '#F0F0F0'
												})}/><ReactMarkdown children={item}/>
											</li>
										))}
									</ul>
								)}

								{ btn && (
									<Button
										className={ s.contentBtn }
										onClick={btn.onClick}
										href={ btn.href }
										label={ btn.text }
										size={"s"}
									/>
								)}
							</div>

							<div
								className={s.imageHolder}
							>
								{illustration && (
									<GatsbyImage
										className={s.illustration}
										alt={heading}
										loading={"eager"}
										image={getImage(illustration)}
									/>
								)}
							</div>
						</div>

						<HeroCustomerLogos customers={socialProofCustomers} titleColor={logoTitleColor} />
					</div>
				</div>
			</div>
		</RootElement>
	);
};
